import { logger as LOG } from '@garnish/logger';

export const adjustLogger = LOG.extend('ADJUST');
